import React from "react";
import { useNavigate, useOutletContext } from "react-router-dom";
import {
  Box,
  Card,
  Divider,
  Flex,
  Grid,
  GridItem,
  Heading,
  Tag,
  Text,
  useColorModeValue,
} from "@chakra-ui/react";
import { FaRegFileAlt, FaRegFolder, FaRegStar } from "react-icons/fa";

function Home() {
  const {
    items,
    articles,
    handleCardClick,
    handleGetArticles,
  } = useOutletContext();
  const navigate = useNavigate();

  // Define color values based on the current color mode
  const dividerColor = useColorModeValue("#dcdcdc", "#4a5568");
  const cardBg = useColorModeValue("white", "#2D3748");
  const headingColor = useColorModeValue("gray.700", "white");
  const hoverBg = useColorModeValue("gray.200", "#4A5568");

  const handleArticleClick = async (item) => {
    handleGetArticles();
    navigate(`/landing/knowledgebase/articles/post/${item._id}`, {
      state: { articleId: item._id },
    });
  };

  const topArticles = articles.sort((a, b) => b.views - a.views).slice(0, 5);

  return (
    <>
      <Grid templateColumns="repeat(2, 1fr)" gap={"20px"}>
        {items.map((item, i) => (
          <GridItem key={i}>
            <Card
              bg={cardBg}
              _hover={{ cursor: "pointer", bg: hoverBg }}
              onClick={() => handleCardClick(item.title)}
            >
              <Flex justify={"space-between"} alignItems={"center"} p={5}>
                <Heading
                  color={headingColor}
                  size={"md"}
                  display={"flex"}
                  gap={2}
                  alignItems={"center"}
                >
                  <FaRegFolder />
                  {item.title}
                  {/* Mapping through tags to display each one separately */}
                  {item.tag.map((singleTag, index) => (
                    <Tag
                      key={index}
                      colorScheme={"blue"}
                      variant={"solid"}
                      ml={1}
                    >
                      {singleTag}
                    </Tag>
                  ))}
                </Heading>
                <Tag size={"lg"} h={"20px"}>
                  <Text as={"b"}>{item.count} Articles</Text>
                </Tag>
              </Flex>
              <Text px={5} pb={5}>
                {item.description}
              </Text>
            </Card>
          </GridItem>
        ))}
      </Grid>
      <Card borderRadius={"4px"} my={"20px"} bg={cardBg}>
        <Box>
          <Heading
            color={headingColor}
            size={"md"}
            display={"flex"}
            gap={1}
            alignItems={"center"}
            p={5}
          >
            <FaRegStar />
            Most Popular Articles
          </Heading>
          <Divider borderColor={dividerColor} />
        </Box>
        {topArticles.map((item, i) => (
          <Box key={i}>
            <Box
              p={4}
              _hover={{ cursor: "pointer", bg: hoverBg }}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              onClick={() => handleArticleClick(item)}
            >
              <Box flex="1" mr={5}>
                <Heading
                  color={headingColor}
                  display={"flex"}
                  gap={1}
                  alignItems={"center"}
                  size={"sm"}
                >
                  <FaRegFileAlt />
                  {item.title}
                  {item.tags.map((tag, i) => (
                    <Tag key={i} colorScheme={"blue"} variant={"solid"}>
                      {tag}
                    </Tag>
                  ))}
                </Heading>
                <Text pl={5}>{item.summary}</Text>
              </Box>
              <Box>
                <Text color={headingColor}>Views: {item.views}</Text>
              </Box>
            </Box>
            <Divider borderColor={dividerColor} />
          </Box>
        ))}
      </Card>
    </>
  );
}

export default Home;
